/**
 * @file 注入请求，错误会直接显示服务端返回的错误
 * @author  fangsimin
 * @date    2019-01-14 19:22:18
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-14 20:54:44
 */

import Vue from 'vue';
import request from '@/common/request';
import DonMessage from '@/plugins/message';

const env = process.env;
let AjaxPlugin = {};

/**
 * 请求插件安装
 * @param  {Object} Vue     vue类
 * @param  {Object} options 配置
 */
AjaxPlugin.install = function (Vue) {
    /**
     * 添加实例方法，请求
     * @param  {Object} reqOptions [description]
     * @param  {Object} data       [description]
     */
    Vue.prototype.$request = function (reqOptions, data) {
        let successCb = reqOptions['success']; // 成功回调
        let errorCb = reqOptions['error']; // 失败回调
        let loadingKey = reqOptions['loadingKey'] || 'loading';
        this[loadingKey] = true;
        let excludeApi = ['/business/cmp/api/addcountractus', '/business/cmp/api/sendsns'];
        // 请求
        request(reqOptions, data).then(response => {
            typeof successCb === 'function' && successCb.call(this, response);
        }, response => {
            if (response && (response.status === 200 || response.status === 304)) {
                if (response.data && (response.data.message || response.data.msg)) {
                    if (response.data.code && excludeApi.indexOf(reqOptions.url) === -1) {
                        DonMessage.error(response.data.message || response.data.msg);
                        // this.$message.error(response.data.message || response.data.msg);
                    }
                } else {
                    DonMessage.error(this.$i18n.t('message.somethingWrong'));
                    // this.$message.error(this.$i18n.t('message.somethingWrong'));
                }
            } else if (response && response.status === 403) {
                let authMessage = response.headers['x-auth-msg'];
                if (authMessage && authMessage === 'auth-failed') {
                    window.location.href = location.protocol + '//' + location.host + '/'
                    + env['MODULE_CMP'] + '/login/?r='
                    + window.location.pathname;
                } else {
                    DonMessage.error(this.$i18n.t('message.permission'));
                }
                // let timer = setTimeout(() => {
                //     window.location.href = 'https://passport.baidu.com/v2/?login&u='
                //         + location.protocol + '//' + location.host + '/' + env['MODULE_CMP'] + '/login/success?r='
                //         + window.location.pathname;
                //     clearTimeout(timer);
                // }, 1200);
            } else if (response && response.status === 410) {
                this.$message.error(this.$i18n.t('message.reLogin'));
                // localStorage.setItem('redirectUrl', window.location.pathname);
                window.location.href = location.protocol + '//' + location.host + '/'
                    + env['MODULE_CMP'] + '/login/?r='
                    + window.location.pathname;
                // clearTimeout(timer);
                // let timer = setTimeout(() => {
                //     // window.location.href = '/business/onboarding';
                // }, 1200);
            } else if (response && (response.status === 502 || response.status === 504)) {
                DonMessage.error(this.$i18n.t('message.ruquestTimeout'));
            } else {
                if (reqOptions.hasInterception && !response) {
                    // 手动取消请求不提示
                    return;
                }
                // 区分超时取消
                if (response.code === 'ECONNABORTED'
                || response.message === 'Network Error'
                || (response.message && response.message.indexOf('timeout') !== -1)) {
                    DonMessage.error(this.$i18n.t('message.ruquestTimeout'));
                    // this.$message.error(this.$i18n.t('message.ruquestTimeout'));
                } else {
                    DonMessage.error(this.$i18n.t('message.networkError'));
                }
                // this.$message.error(this.$i18n.t('message.networkError'));
            }
            typeof errorCb === 'function' && errorCb.call(this, response);
        }).finally(() => {
            this[loadingKey] = false;
        });
    };
};

Vue.use(AjaxPlugin);



// WEBPACK FOOTER //
// ./src/plugins/ajax.js